<template>
  <div class="relative body-text">
    <div
      v-if="loading"
      class="absolute h-screen w-screen inset-0 flex justify-center align-center"
    >
      <div class="m-auto" v-loading="true"></div>
    </div>
    <template v-else>
      <div class="fixed right-0 pt-5 pr-5 print:hidden">
        <button onclick="window.print()" title="打印">
          <i
            class="el-icon-printer text-4xl text-gray-400 hover:text-black"
          ></i>
        </button>
      </div>
      <div
        class="container mx-auto flex flex-col justify-evenly items-center pt-10 h-screen print:h-screen"
      >
        <div
          class="text-center xl:text-4xl text-3xl print:text-3xl font-semibold space-y-3"
        >
          <div class="main-title">中小企业数字化水平评测简报</div>
        </div>
        <div class="flex flex-col space-y-1">
          <div class="flex">
            <span class="">企业名称：</span>
            <span class="flex-1 border-b border-black border-solid">{{
              info.strThree
            }}</span>
          </div>
          <div class="flex">
            <span class="">评测机构：</span>
            <span class="flex-1 border-b border-black border-solid">{{
              info.strFive
            }}</span>
          </div>
          <div class="flex">
            <span class="">报告编号：</span>
            <span class="flex-1 border-b border-black border-solid">{{
              info.reportNum
            }}</span>
          </div>
          <div class="flex">
            <span class="">报告日期：</span>
            <span
              class="flex-1 border-b border-black border-solid overflow-hidden"
              >{{
                info.reportDate
                  .substring(0, 10)
                  .replace("-", "年")
                  .replace("-", "月")
                  .concat("日")
              }}</span
            >
          </div>
        </div>
      </div>

      <div class="page-break"></div>

      <div class="container mx-auto pt-10 h-screen print:h-screen">
        <div class="text-center main-title mb-10">报告声明</div>
        <div class="space-y-5">
          <div class="report-text space-y-2">
            <p class="h3-title">1：评测依据</p>
            <p>
              本报告依据《中小企业数字化水平评测指标（2024版）》从数字化基础、管理、成效和经营四个维度对中小企业数字化发展水平进行综合评估。
            </p>
          </div>
          <div class="report-text space-y-2">
            <p class="h3-title">2：评测方法</p>
            <p>
              企业登陆吉林市中小企业数字化水平调研服务系统（网址
              https://dtms.mesync.cn）完成问卷填报，评审专家通过线上评审及现场核验方式完成评测。
            </p>
          </div>
          <div class="report-text space-y-2">
            <p class="h3-title">3：报告使用范围</p>
            <p>
              本报告依据企业当次填报数据出具，旨在帮助企业了解自身的数字化转型现状，识别数字化转型中的优势与不足，提出发展建议，助力企业数字化转型。本报告使用范围及最终解释权归吉林市工业和信息化局所有。
            </p>
          </div>
        </div>
      </div>

      <div class="page-break"></div>

      <div class="container mx-auto">
        <div class="report-text">
          <p class="h1-title">一、公司简介</p>
          <p>{{ info.strFour }}</p>
        </div>
      </div>

      <div class="page-break"></div>

      <div class="container mx-auto my-10">
        <div class="report-text">
          <p class="my-2 h1-title">二、评测结果分析</p>
          <p class="my-1 h2-title">（一）总体情况分析</p>
          <p>
            {{ info.p_2_1 }}
          </p>
        </div>
      </div>

      <div class="page-break"></div>

      <div
        class="container mx-auto mb-10 h-screen print:h-screen flex flex-col"
      >
        <div class="report-text">
          <p class="h1-title">二、相关附件</p>
          <p>
            <button @click="handleExportExcel" class="h2-title">
              （一）中小企业数字化水平评测表
            </button>
          </p>
          <p>
            <button @click="handleExportDevice" class="h2-title">
              （二）设备清单
            </button>
          </p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import "@/assets/app.css";
import * as XLSX from "xlsx";
import { getFile, makeExportExcel } from "@/api/enterprise";
export default {
  data() {
    return {
      loading: true,
      table1: [],
      table2: [],
      table3: [],
      table4: [],
      table5: [],
      table6: [],
      echarts: [],
      info: {},
    };
  },
  created() {
    if (!window.opener) {
      window.close();
    }
  },
  mounted() {
    window.addEventListener("message", this.handleMessage);
    window.opener.postMessage("getEnterpriseReport");
  },
  destroyed() {
    window.removeEventListener("message", this.handleMessage);
  },
  methods: {
    handleMessage({ data }) {
      try {
        this.info = JSON.parse(data);
        console.log(this.info);
        this.loading = false;
        window.removeEventListener("message", this.handleMessage);
      } catch (e) {
        console.log("error", e);
      }
    },
    async handleExportExcel() {
      const excel = await makeExportExcel([this.info.userId]);
      if (excel.code !== 200) {
        return Promise.reject(new Error("导出失败"));
      }
      await getFile(excel.message)
        .then((res) => res.data)
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `${this.info.strThree}-数字化水平评测表.xlsx`;
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
        });
    },
    handleExportDevice() {
      const list = this.info.answerArr[1]?.otherAns?.list ?? [];
      const arr = [
        ["车间名称", "plant"],
        ["产线名称", "line"],
        ["设备编号", "code"],
        ["设备名称", "name"],
        ["设备分类", "type"],
        ["规格/型号", "size"],
        ["品牌/厂商", "factory"],
        ["入场日期", "date"],
        ["设备状态", "status"],
        ["是否已联网", "online"],
        ["是否已数控化", "digit"],
        ["是否已实时采集数据", "real"],
        ["保养周期（日）", "during"],
        ["上次保养的日期", "last"],
      ];
      const ws = XLSX.utils.json_to_sheet(
        list.map((v) =>
          arr.reduce((o, a) => Object.assign(o, { [a[0]]: v[a[1]] }), {})
        )
      );
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      XLSX.writeFile(wb, `${this.info.strThree}-设备清单.xlsx`);
    },
  },
};
</script>

<style scoped>
.main-title {
  font-family: "FZXSJW", "方正小标宋", sans-serif;
  @apply text-3xl;
}

.h1-title {
  font-family: "SimHei", "黑体", sans-serif;
  @apply text-xl;
}

.h2-title {
  font-family: "KaiTi", "楷体", serif;
  @apply text-xl font-bold;
}

.h3-title,
.h4-title,
h5-title,
body-text {
  font-family: "FangSong", "仿宋", serif;
  @apply text-xl;
}
@media print {
  .print\:hidden {
    display: none;
  }
  .print\:h-screen {
    @apply h-screen;
  }
  @page {
    margin: 2cm;
  }
  .page-break {
    page-break-after: always;
  }
  .chart-container {
    width: 400px !important;
    height: 400px !important;
  }
  .table-container {
  }
  * {
    print-color-adjust: exact;
    -webkit-print-color-adjust: exact;
  }
}
.report-text > p {
  text-indent: 2rem;
  word-break: break-word;
}
</style>
